import Vue from "vue";

let pickingPromise = null;
let styleInjected = false;

function injectPickerStyle() {
    if (styleInjected || typeof document === "undefined") {
        return;
    }
    styleInjected = true;
    const style = document.createElement("style");
    style.textContent = `
.pick-company-identity-dialog .pick-company-tip {
    margin: 0 0 16px;
    color: #606266;
    line-height: 1.5;
}
.pick-company-identity-dialog .pick-company-group {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    max-height: 40vh;
    overflow-y: auto;
}
.pick-company-identity-dialog .pick-company-radio {
    display: flex;
    align-items: center;
    margin: 0 0 10px;
    white-space: normal;
}
.pick-company-identity-dialog .pick-company-name {
    max-width: 260px;
    overflow: hidden;
    text-overflow: ellipsis;
}
.pick-company-identity-dialog .pick-company-role {
    color: #b88230;
    margin-left: 4px;
}
`;
    document.head.appendChild(style);
}

function destroyPicker(instance) {
    if (!instance) return;
    instance.$destroy();
    if (instance.$el && instance.$el.parentNode) {
        instance.$el.parentNode.removeChild(instance.$el);
    }
}

/**
 * 弹出企业身份选择；仅一家时直接返回，取消返回 null
 * @param {Array<{cname: string, cid: number, role?: string}>} companies
 * @returns {Promise<Object|null>}
 */
export function pickCompanyIdentity(companies = []) {
    const list = Array.isArray(companies) ? companies.filter(Boolean) : [];
    if (!list.length) {
        return Promise.resolve(null);
    }
    if (list.length === 1) {
        return Promise.resolve(list[0]);
    }
    if (pickingPromise) {
        return pickingPromise;
    }

    pickingPromise = new Promise((resolve) => {
        const Picker = Vue.extend({
            name: "PickCompanyIdentity",
            data() {
                return {
                    visible: true,
                    selected: list[0].cname,
                    companies: list,
                };
            },
            methods: {
                finish(company) {
                    this.visible = false;
                    this.$nextTick(() => {
                        destroyPicker(this);
                        resolve(company || null);
                    });
                },
                confirm() {
                    const company =
                        this.companies.find(
                            (item) => item.cname === this.selected,
                        ) || null;
                    this.finish(company);
                },
                cancel() {
                    this.finish(null);
                },
                roleText(role) {
                    return role === "Management" ? "管理员" : "普通员工";
                },
            },
            render(h) {
                const useSelect = this.companies.length > 8;
                const options = this.companies.map((item) => {
                    if (useSelect) {
                        return h("el-option", {
                            key: item.cid,
                            props: {
                                label: `${item.cname}（${this.roleText(
                                    item.role,
                                )}）`,
                                value: item.cname,
                            },
                        });
                    }
                    return h(
                        "el-radio",
                        {
                            key: item.cid,
                            props: { label: item.cname },
                            class: "pick-company-radio",
                        },
                        [
                            h("span", { class: "pick-company-name" }, item.cname),
                            h(
                                "span",
                                { class: "pick-company-role" },
                                `（${this.roleText(item.role)}）`,
                            ),
                        ],
                    );
                });

                const body = useSelect
                    ? h(
                          "el-select",
                          {
                              props: {
                                  value: this.selected,
                                  filterable: true,
                                  placeholder: "请选择企业身份",
                              },
                              on: {
                                  input: (val) => {
                                      this.selected = val;
                                  },
                              },
                              style: { width: "100%" },
                          },
                          options,
                      )
                    : h(
                          "el-radio-group",
                          {
                              props: { value: this.selected },
                              on: {
                                  input: (val) => {
                                      this.selected = val;
                                  },
                              },
                              class: "pick-company-group",
                          },
                          options,
                      );

                return h(
                    "el-dialog",
                    {
                        props: {
                            visible: this.visible,
                            title: "请选择企业身份",
                            appendToBody: true,
                            closeOnClickModal: false,
                            closeOnPressEscape: false,
                            showClose: false,
                            width: "480px",
                            customClass: "pick-company-identity-dialog",
                        },
                    },
                    [
                        h(
                            "p",
                            { class: "pick-company-tip" },
                            "当前功能需要企业身份，请选择要使用的企业：",
                        ),
                        body,
                        h(
                            "span",
                            { slot: "footer", class: "dialog-footer" },
                            [
                                h(
                                    "el-button",
                                    { on: { click: this.cancel } },
                                    "取消",
                                ),
                                h(
                                    "el-button",
                                    {
                                        props: { type: "primary" },
                                        on: { click: this.confirm },
                                    },
                                    "确定",
                                ),
                            ],
                        ),
                    ],
                );
            },
        });

        const instance = new Picker();
        injectPickerStyle();
        instance.$mount();
        document.body.appendChild(instance.$el);
    }).finally(() => {
        pickingPromise = null;
    });

    return pickingPromise;
}
